import { auth } from "../infrastructure/firebase";

export const signin = async (
  id: string,
  password: string
): Promise<void | string> => {
  const email = id + "@recopo.info";
  try {
    await auth.signInWithEmailAndPassword(email, password);
  } catch (e: any) {
    switch (e?.code) {
      case "auth/invalid-email":
        return "メールアドレスの入力に誤りがあります。";
      case "auth/user-disabled":
        return "退会済みのユーザーです。";
      case "auth/user-not-found":
        return "IDの入力に誤りがあります。";
      case "auth/wrong-password":
        return "パスワードの入力に誤りがあります。";
      default:
        return "ネットワークエラー。";
    }
  }
};
